
import { defineComponent } from 'vue'
import DatePicker from '@/components/date-picker/DatePicker.vue'
import { getFiltersData, initFilterOptions } from '@/utils/filters'
import {
  lookupCampaigns,
  lookupGeos,
  lookupLandings,
  lookupOfferCategories,
  lookupOffers,
  lookupTrafficProperties,
} from '@/utils/lookups'
import { getDefaultFilters } from '@/utils/request'
import { mapState } from 'vuex'

export default defineComponent({
  name: 'FiltersDialog',
  components: { DatePicker },
  props: ['open', 'close', 'reset', 'currentFilters', 'changeFilters'],
  async created() {
    await initFilterOptions(this)
  },
  computed: {
    ...mapState('authModule', ['isMB']),
    showDialog(): boolean {
      return this.open
    },
    hideForStatistics(): boolean {
      return !this.$route.path.includes('statistics')
    },
    hideForConversions(): boolean {
      return !this.$route.path.includes('conversions')
    },
    hideForCampaigns(): boolean {
      return !this.$route.path.includes('campaigns')
    },
    hideForOffers(): boolean {
      return !this.$route.path.includes('offers')
    },
    hideForPostbacks(): boolean {
      return !this.$route.path.includes('postbacks')
    },
  },
  data: function() {
    return {
      filters: { ...this.currentFilters },
      ...getFiltersData(),
    }
  },
  watch: {
    search() {
      this.onChangeFilters('name', this.search)
    },
    currentFilters() {
      this.filters = { ...this.currentFilters }
      this.search = this.currentFilters.name
    },
  },
  methods: {
    addFilters() {
      this.$emit('changeFilters', this.filters)
      this.$emit('close')
    },
    resetFilters() {
      this.search = null
      this.filters = getDefaultFilters(true)
      this.$emit('changeFilters', this.filters)
    },
    onChangeFilters(field: string, value: string | null) {
      if (field === 'vertical') {
        this.filters.offerCategoryId = null
      }
      this.filters[field] = value
    },
    async getOffers(value: string, update: Function) {
      await lookupOffers(this, value, update)
    },
    async getCampaigns(value: string, update: Function) {
      await lookupCampaigns(this, value, update)
    },
    async getGeos(value: string, update: Function) {
      await lookupGeos(this, value, update, false, this.isMB)
    },
    async getTrafficProperties(value: string, update: Function) {
      await lookupTrafficProperties(this, value, update)
    },
    async getOfferCategories(value: string, update: Function) {
      await lookupOfferCategories(this, value, update)
    },
    async getLandings(
      value: string,
      update: Function,
      isLandingFilter: boolean,
    ) {
      await lookupLandings(this, value, update, isLandingFilter)
    },
    onChangeDate(date: string[]) {
      this.filters.dateFrom = date[0]
      this.filters.dateTo = date[1]
      this.$emit('changeAll', this.filters)
    },
    onChangeConversionDate(date: string[]) {
      this.filters.conversionDateFrom = date[0]
      this.filters.conversionDateTo = date[1]
      this.$emit('changeAll', this.filters)
    },
  },
})
